import { useMutation, useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';
import { useAuthStore } from '../../../store/useAuthStore';

export const useCreateOperator = (options = {}) => {
  return useMutation({
    mutationKey: ['createClient'],
    mutationFn: async (data) => {
      await httpService.post(`operator/create`, data);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useUpdateOperator = (token, options = {}) => {
  return useMutation({
    mutationKey: ['createClient'],
    mutationFn: async ({ data, id }) => {
      await httpService.post(`operator/update/${id}`, data);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useGetSingleOperator = ({ id, options = {} }) => {
  return useQuery({
    queryKey: ['getSingleClient', id],
    queryFn: async () => {
      const response = await httpService.get(`operator/single-operator/${id}`);

      return response?.data?.data;
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useGetSelectOperator = () => {
  const { user } = useAuthStore();
  const canSelectOperator =
    user?.role === 'SUPER_ADMIN' || user?.role === 'READ_ONLY_ADMIN' || user?.role === 'ADMIN';

  return useQuery({
    queryKey: ['getSingleClient'],
    queryFn: async () => {
      const response = await httpService.get(
        `operator/select-operator?limit=1000`
      );
      return response?.data?.data;
    },
    enabled: canSelectOperator,
    refetchOnWindowFocus: false,
  });
};

export const useToggleOperatorBlock = (options = {}) => {
  return useMutation({
    mutationKey: ['ToggleBlock'],
    mutationFn: async ({ id, status }) => {
      await httpService.post(`operator/block-unblock/${id}`, { status });
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useDeleteOperator = (options = {}) => {
  return useMutation({
    mutationKey: ['deleteOperator'],
    mutationFn: async (id) => {
      await httpService.delete(`operator/delete/${id}`);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useGetPaymentDetails = ({ id, options = {} }) => {
  return useQuery({
    queryKey: ['getPaymentDetails', id],
    queryFn: async () => {
      const response = await httpService.get(`operator/payment-details/${id}`);
      return response?.data?.data;
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useCreatePaymentDetails = (options = {}) => {
  return useMutation({
    mutationKey: ['createPaymentDetails'],
    mutationFn: async ({ id, data }) => {
      await httpService.post(`operator/payment-details/${id}`, data);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useUpdatePaymentDetails = (options = {}) => {
  return useMutation({
    mutationKey: ['updatePaymentDetails'],
    mutationFn: async ({ id, data }) => {
      await httpService.put(`operator/payment-details/update/${id}`, data);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};
